export function buildWorkspaceScalesListQueryV1(workspaceId: number)
{
	return {
		'$type': 'TCh.Domain.Scales.Queries.WorkspaceScalesListQueryV1, TCh.Domain.Scales',
		'WorkspaceId': workspaceId,
	}
}

export function buildTchScaleTemplatesListQueryV1(workspaceId: number)
{
	return {
		'$type': 'TCh.Domain.Scales.Queries.TchScaleTemplatesListQueryV1, TCh.Domain.Scales',
		'WorkspaceId': workspaceId,
	}
}






